export default __webpack_public_path__ + "static/media/waiting_room_bg.25c67cae.jpg";